import { Avatar } from '@sanlam-glacier/app-common/components';
import { VerticalDivider } from '../vertical-divider/VerticalDivider';
import styles from './app-bar-avatar.module.scss';

export const AppBarAvatar = () => {
  return (
    <>
      <div className={styles.avatarContainer}>
        <VerticalDivider />
        <Avatar>EG</Avatar>
      </div>
    </>
  );
};
